// File: AddSurveyorForm.jsx

import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import { getData } from "../../../API";

function UnVerifiedReportAddForm() {
  const navigate = useNavigate();
  const [masterData, setMasterData] = useState({
    establishmentTypes: [],
    ownershipTypes: [],
    serviceStatuses: [],
    zones: [],
    wards: [],
    commercialTypes: [],
    rateCategories: [],
    rateSubCategories: [],
  });

  const [loading, setLoading] = useState(true);

  const initialValues = {
    typeOfEstablishment: "",
    EstablishmentType: "",
    ownershipType: "",
    serviceStatus: "",
    municipalRegNo: "",
    MunicipalCommercialNo: "",
    registrationStartDate: "",
    registrationEndDate: "",
    HouseNo: "",
    ownerName: "",
    ownerContactNo: "",
    emailId: "",
    minWasteQty: "",
    commercialType: "",
    RateType: "",
    rate: "",
    rateCategoryId: "",
    RateCategoryName: "",
    rateSubCategoryId: "",
    RateSubCategoryName: "",
    fixedValue: "",
    extraArea: "",
    tenantName: "",
    tenantContact: "",
    noOfMembers: "",
    address: "",
    location: "",
    lat: "",
    lng: "",
    landmark: "",
    remarks: "",
    zoneId: "",
    zoneNo: "",
    wardNo: "",
    isCommercial: false,
    // isActive: true,
    imageUrl: "",
  };
  const validationSchema = Yup.object({
    typeOfEstablishment: Yup.string().required(
      "Type Of Establishment is required"
    ),
    ownershipType: Yup.string().required("OwnershipType is required"),
    serviceStatus: Yup.string().required("Service status is required"),
    municipalRegNo: Yup.string().nullable(),
    MunicipalCommercialNo: Yup.string().when("isCommercial", {
    is: "true",
    then: (schema) => schema.required("Municipal Commercial No is required"),
    otherwise: (schema) => schema.notRequired().nullable(),
    }),
    registrationStartDate: Yup.date().typeError("Please enter a valid date"),
    registrationEndDate: Yup.date()
      .typeError("Please enter a valid date")
      .min(
        Yup.ref("registrationStartDate"),
        "End date cannot be before start date"
      ),
    HouseNo: Yup.string().required("Property House No is required"),
    ownerName: Yup.string().required("Owner name is required").min(2),
    ownerContactNo: Yup.string()
      .nullable()
      .matches(
        /^[6-9][0-9]{9}$/,
        "Contact must be valid 10 digit starting with 6-9"
      ),
    tenantContact: Yup.string()
      .nullable()
      .matches(
        /^[6-9][0-9]{9}$/,
        "Contact must be valid 10 digit starting with 6-9"
      ),
    emailId: Yup.string().nullable().email("Invalid email format"),
    minWasteQty: Yup.number().typeError("Must be a number").min(0).nullable(),
    rateCategoryId: Yup.string().required("Rate Category is required"),
    rateSubCategoryId: Yup.string().required("Rate Sub Category is required"),
    fixedValue: Yup.number().typeError("Must be a number").min(0).nullable(),
    extraArea: Yup.number().typeError("Must be a number").min(0).nullable(),
    tenantName: Yup.string().nullable().min(2),
    noOfMembers: Yup.number().required().min(1).typeError("Must be a number"),
    address: Yup.string().required().min(5),
    lat: Yup.number()
      .required()
      .min(-90)
      .max(90)
      .typeError("Must be a valid number"),
    lng: Yup.number()
      .required()
      .min(-180)
      .max(180)
      .typeError("Must be a valid number"),
    zoneNo: Yup.string().required("Zone is required"),
    wardNo: Yup.string().required("Ward is required"),
    isCommercial: Yup.string().required("Commercial Room Attached is required"),
    // isActive: Yup.boolean().required(),
    imageUrl: Yup.mixed().test(
      "required-file",
      "Image is required",
      (value) => (value && value instanceof File) || typeof value === "string"
    ),
  });

  useEffect(() => {
    const fetchMasterData = async () => {
      try {
        setLoading(true);
        const response = await getData("SurveyMasters/GetAllMaster");
        const response1 = await getData("SurveyMasters/CommercialTypes");
        setMasterData({
          establishmentTypes: response.data.estabishmentType || [],
          ownershipTypes: response.data.ownershipTypes || [],
          serviceStatuses: response.data.serviceStatus || [],
          zones: response.data.zone || [],
          wards: response.data.wards || [],
          commercialTypes: response1.data || [],
          rateCategories: response.data.rateCategory || [],
          rateSubCategories: response.data.rateSubCategory || [],
        });
      } catch (error) {
        toast.error("Failed to load master data");
      } finally {
        setLoading(false);
      }
    };
    fetchMasterData();
  }, []);

  const handleSubmit = async (values, { setSubmitting }) => {
    const formData = new FormData();
    formData.append("EstablishmentTypeId", values.typeOfEstablishment);
    formData.append("EstablishmentType", values.EstablishmentType);
    formData.append("OwnerShipType", values.ownershipType);
    formData.append("ServiceStatusId", values.serviceStatus);
    formData.append("MuncipalRegNo", values.municipalRegNo);
    formData.append("MunicipalCommercialNo", values.MunicipalCommercialNo);
    formData.append("RegistrationStartDate", values.registrationStartDate);
    formData.append("RegistrationEndDate", values.registrationEndDate);
    formData.append("HouseNo", values.HouseNo);
    formData.append("ownerName", values.ownerName);
    formData.append("ownerContactNo", values.ownerContactNo);
    formData.append("EmailId", values.emailId);
    formData.append("MinWasteQty", values.minWasteQty);
    formData.append("CommercialType", values.commercialType);
    formData.append("RateType", values.RateType);
    formData.append("DisplayRate", values.rate);
    formData.append("RateCategoryId", values.rateCategoryId);
    formData.append("RateCategoryName", values.RateCategoryName);
    formData.append("RateSubCategoryId", values.rateSubCategoryId);
    formData.append("RateSubCategoryName", values.RateSubCategoryName);
    formData.append("ExtraArea", values.extraArea);
    formData.append("TenantName", values.tenantName);
    formData.append("TenantContactNo", values.tenantContact);
    formData.append("NoOfMembers", values.noOfMembers);
    formData.append("Address", values.address);
    formData.append("Lat", values.lat);
    formData.append("Lng", values.lng);
    formData.append("Landmark", values.landmark);
    formData.append("Remarks", values.remarks);
    formData.append("ZoneId", values.ZoneId);
    formData.append("ZoneNo", values.zoneNo);
    formData.append("WardNo", values.wardNo);
    formData.append("IsCommercialRoomAttached", values.isCommercial);
    // formData.append("IsActive", values.isActive);

    if (values.imageUrl) {
      formData.append("SurveyImage", values.imageUrl); // This must be a File object
    }
    try {
      //   const formData = new FormData();

      //   for (const key in values) {
      //     formData.append(key, values[key]);
      //     console.log(formData)
      //   }
      const token = localStorage.getItem("token");
      const response = await axios.post(
        // "https://lsadevapi.vmaxtechservices.help/api/SurveyDetails/AddWebSurveySubDetailOffline",
         "https://lsaapi.lucknowswachhata.com/api/SurveyDetails/AddWebSurveySubDetailOffline",
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "multipart/form-data",
          },
        }
      );

      if (response.status === 200) {
        toast.success("Surveyor added successfully");
        navigate("/reports");
      }
    } catch (error) {
      toast.error(
        error.response?.data?.message || "Error occurred while submitting form"
      );
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div>
      <ToastContainer />
      <main className="page-content content">
        <div className="container-fluid p-0">
          <div className="d-flex justify-content-between align-items-center mb-3">
            <h1 className="title_pages mb-0">Add UnVerified Form</h1>
            <Link
              to="/reports"
              className="btn btn-secondary"
              style={{ boxShadow: "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px" }}
            >
              <i className="fa-solid fa-arrow-left-long me-1"></i> Back
            </Link>
          </div>
          <div className="container mt-4">
            <Formik
              initialValues={initialValues}
              validationSchema={validationSchema}
              onSubmit={handleSubmit}
            >
              {({ values, handleChange, isSubmitting, setFieldValue }) => (
                <Form>
                  <div className="row">
                    <div className="col-md-3 mb-3">
                      <label className="form-label">
                        Type Of Establishment{" "}
                        <span className="text-danger">*</span>
                      </label>
                      <Field
                        as="select"
                        className={`form-select `}
                        name="typeOfEstablishment"
                        onChange={(e) => {
                          const selectedEstablishmentTypeId = e.target.value;
                          const selectedEstablishment =
                            masterData.establishmentTypes.find(
                              (category) =>
                                category.establishmentTypeId ==
                                selectedEstablishmentTypeId
                            );
                          handleChange(e);
                          setFieldValue(
                            "EstablishmentType",
                            selectedEstablishment?.establishmentTypeName || ""
                          );
                        }}
                      >
                        <option value="">Select Type</option>
                        {masterData.establishmentTypes.map((type) => (
                          <option
                            key={type.establishmentTypeId}
                            value={type.establishmentTypeId}
                          >
                            {type.establishmentTypeName}
                          </option>
                        ))}
                      </Field>
                      <ErrorMessage
                        name="typeOfEstablishment"
                        component="div"
                        className="text-danger"
                      />
                    </div>

                    <div className="col-md-3 mb-3">
                      <label className="form-label">
                        Ownership Type<span className="text-danger">*</span>
                      </label>
                      <Field
                        as="select"
                        className={`form-select `}
                        name="ownershipType"
                      >
                        <option value="">Select Type</option>
                        {masterData.ownershipTypes.map((type) => (
                          <option
                            key={type.ownershipTypeId}
                            value={type.ownershipTypeId}
                          >
                            {type.ownershipTypeName}
                          </option>
                        ))}
                      </Field>
                      <ErrorMessage
                        name="ownershipType"
                        component="div"
                        className="text-danger"
                      />
                    </div>

                    <div className="col-md-3 mb-3">
                      <label className="form-label">
                        Service Status <span className="text-danger">*</span>
                      </label>
                      <Field
                        as="select"
                        className={`form-select `}
                        name="serviceStatus"
                      >
                        <option value="">Select Status</option>
                        {masterData.serviceStatuses.map((status) => (
                          <option
                            key={status.serviceStatusId}
                            value={status.serviceStatusId}
                          >
                            {status.serviceStatusName}
                          </option>
                        ))}
                      </Field>
                      <ErrorMessage
                        name="serviceStatus"
                        component="div"
                        className="text-danger"
                      />
                    </div>

                    <div className="col-md-3 mb-3">
                      <label className="form-label">Municipal Reg No</label>
                      <Field
                        type="text"
                        className={`form-control`}
                        name="municipalRegNo"
                      />
                    </div>

                    {/* Registration date fields */}
                    <div className="col-md-3 mb-3">
                      <label className="form-label">
                        Registration Start Date
                      </label>
                      <Field
                        type="date"
                        className={`form-control `}
                        name="registrationStartDate"
                      />
                    </div>

                    <div className="col-md-3 mb-3">
                      <label className="form-label">
                        Registration End Date
                      </label>
                      <Field
                        type="date"
                        className={`form-control `}
                        name="registrationEndDate"
                      />
                    </div>

                    {/* Owner details fields */}
                    <div className="col-md-3 mb-3">
                      <label className="form-label">
                        Property House No <span className="text-danger">*</span>
                      </label>
                      <Field
                        type="text"
                        className={`form-control `}
                        name="HouseNo"
                      />
                      <ErrorMessage
                        name="HouseNo"
                        component="div"
                        className="text-danger"
                      />
                    </div>

                    <div className="col-md-3 mb-3">
                      <label className="form-label">
                        Owner Name <span className="text-danger">*</span>
                      </label>
                      <Field
                        type="text"
                        className={`form-control `}
                        name="ownerName"
                      />
                      <ErrorMessage
                        name="ownerName"
                        component="div"
                        className="text-danger"
                      />
                    </div>

                    <div className="col-md-3 mb-3">
                      <label className="form-label">Owner Contact No</label>
                      <Field
                        type="text"
                        className={`form-control `}
                        name="ownerContactNo"
                        maxLength={10}
                      />
                    </div>

                    <div className="col-md-3 mb-3">
                      <label className="form-label">Email ID</label>
                      <Field
                        type="text"
                        className={`form-control`}
                        name="emailId"
                      />
                    </div>

                    {/* Commercial/Rate fields */}
                    <div className="col-md-3 mb-3">
                      <label className="form-label">Min Waste Qty</label>
                      <Field
                        type="text"
                        className={`form-control `}
                        name="minWasteQty"
                      />
                    </div>

                    <div className="col-md-3 mb-3">
                      <label className="form-label">Commercial Type</label>
                      <Field
                        as="select"
                        className={`form-select `}
                        name="commercialType"
                      >
                        <option value="">Select Type</option>
                        {masterData.commercialTypes.map((type) => (
                          <option
                            key={type.commercialTypeId}
                            value={type.commercialTypeId}
                          >
                            {type.commercialTypeName}
                          </option>
                        ))}
                      </Field>
                    </div>

                    <div className="col-md-3 mb-3">
                      <label className="form-label">
                        Category <span className="text-danger">*</span>
                      </label>
                      <Field
                        as="select"
                        className="form-select"
                        name="rateCategoryId"
                        onChange={(e) => {
                          const selectedCategoryId = e.target.value;
                          const selectedCategory =
                            masterData.rateCategories.find(
                              (category) =>
                                category.rateCategoryId == selectedCategoryId
                            );
                          handleChange(e);
                          setFieldValue("rateSubCategoryId", ""); // clear sub-category

                          setFieldValue(
                            "RateCategoryName",
                            selectedCategory?.rateCategoryName || ""
                          ); // set name
                        }}
                      >
                        <option value="">Select Category</option>
                        {masterData.rateCategories.map((category) => (
                          <option
                            key={category.rateCategoryId}
                            value={category.rateCategoryId}
                          >
                            {category.rateCategoryName}
                          </option>
                        ))}
                      </Field>

                      <ErrorMessage
                        name="rateCategoryId"
                        component="div"
                        className="text-danger"
                      />
                    </div>

                    <div className="col-md-3 mb-3">
                      <label className="form-label">
                        Sub Category <span className="text-danger">*</span>
                      </label>
                      <Field
                        as="select"
                        className={`form-select`}
                        name="rateSubCategoryId"
                        onChange={(e) => {
                          const selectedCategoryId = e.target.value;
                          const selectedCategory =
                            masterData.rateSubCategories.find(
                              (category) =>
                                category.rateSubCategoryId == selectedCategoryId
                            );
                          handleChange(e);
                          setFieldValue(
                            "RateSubCategoryName",
                            selectedCategory?.subCategoryName || ""
                          ); // set name
                        }}
                        // disabled={!values.rateCategoryId}
                      >
                        <option value="">Select Sub Category</option>
                        {masterData.rateSubCategories
                          .filter(
                            (subCategory) =>
                              !values.rateCategoryId ||
                              subCategory.rateCategoryId ===
                                parseInt(values.rateCategoryId)
                          )
                          .map((subCategory) => (
                            <option
                              key={subCategory.rateSubCategoryId}
                              value={subCategory.rateSubCategoryId}
                            >
                              {subCategory.subCategoryName}
                            </option>
                          ))}
                      </Field>
                      <ErrorMessage
                        name="rateSubCategoryId"
                        component="div"
                        className="text-danger"
                      />
                    </div>

                    <div className="col-md-3 mb-3">
                      <label className="form-label">Rate Type</label>
                      <Field
                        type="text"
                        className={`form-control `}
                        name="RateType"
                      />
                      <ErrorMessage
                        name="rateType"
                        component="div"
                        className="text-danger"
                      />
                    </div>

                    <div className="col-md-3 mb-3">
                      <label className="form-label">Rate</label>
                      <Field
                        type="text"
                        className={`form-control `}
                        name="rate"
                      />
                      <ErrorMessage
                        name="rate"
                        component="div"
                        className="text-danger"
                      />
                    </div>

                    <div className="col-md-3 mb-3">
                      <label className="form-label">Fixed Value</label>
                      <Field
                        type="text"
                        // className="form-control"
                        className={`form-control `}
                        name="fixedValue"
                      />
                    </div>

                    <div className="col-md-3 mb-3">
                      <label className="form-label">Extra Area</label>
                      <Field
                        type="text"
                        className={`form-control `}
                        name="extraArea"
                      />
                    </div>

                    <div className="col-md-3 mb-3">
                      <label className="form-label">Tenant Name</label>
                      <Field
                        type="text"
                        className={`form-control `}
                        name="tenantName"
                      />
                    </div>

                    <div className="col-md-3 mb-3">
                      <label className="form-label">Tenant Contact</label>
                      <Field
                        type="text"
                        className={`form-control `}
                        name="tenantContact"
                        maxLength={10}
                      />
                    </div>

                    <div className="col-md-3 mb-3">
                      <label className="form-label">
                        No Of Family Members
                        <span className="text-danger">*</span>
                      </label>
                      <Field
                        type="number"
                        className={`form-control `}
                        name="noOfMembers"
                      />
                      <ErrorMessage
                        name="noOfMembers"
                        component="div"
                        className="text-danger"
                      />
                    </div>

                    <div className="col-md-3 mb-3">
                      <label className="form-label">
                        Address <span className="text-danger">*</span>
                      </label>
                      <Field
                        type="text"
                        className={`form-control `}
                        name="address"
                      />
                      <ErrorMessage
                        name="address"
                        component="div"
                        className="text-danger"
                      />
                    </div>
                    <div className="col-md-3 mb-3">
                      <label className="form-label">
                        Latitude<span className="text-danger">*</span>
                      </label>
                      <Field
                        type="text"
                        className={`form-control`}
                        name="lat"
                      />
                      <ErrorMessage
                        name="lat"
                        component="div"
                        className="text-danger"
                      />
                    </div>

                    <div className="col-md-3 mb-3">
                      <label className="form-label">
                        Longitude<span className="text-danger">*</span>
                      </label>
                      <Field
                        type="text"
                        className={`form-control`}
                        name="lng"
                      />
                      <ErrorMessage
                        name="lng"
                        component="div"
                        className="text-danger"
                      />
                    </div>

                    <div className="col-md-3 mb-3">
                      <label className="form-label">Landmark</label>
                      <Field
                        type="text"
                        className={`form-control`}
                        name="landmark"
                      />
                    </div>

                    <div className="col-md-3 mb-3">
                      <label className="form-label">Remarks</label>
                      <Field
                        type="text"
                        className={`form-control `}
                        name="remarks"
                      />
                    </div>

                    <div className="col-md-3 mb-3">
                      <label className="form-label">
                        Zone<span className="text-danger">*</span>
                      </label>
                      <Field
                        as="select"
                        className={`form-select `}
                        name="zoneNo"
                        onChange={(e) => {
                          const selectedZoneId = e.target.value;
                          const selectedZone = masterData.zones.find(
                            (category) => category.zoneNo == selectedZoneId
                          );

                          handleChange(e);
                          setFieldValue("wardNo", ""); // clear sub-category
                          setFieldValue(
                            "ZoneId",
                            selectedZone?.uccZoneId || ""
                          );
                        }}
                      >
                        <option value="">Select Zone</option>
                        {masterData.zones.map((zone) => (
                          <option key={zone.zoneNo} value={zone.zoneNo}>
                            {zone.zoneName}
                          </option>
                        ))}
                      </Field>
                      <ErrorMessage
                        name="zoneNo"
                        component="div"
                        className="text-danger"
                      />
                    </div>

                    {/* Display the actual wardNo value from the response */}
                    <div className="col-md-3 mb-3">
                      <label className="form-label">
                        Ward<span className="text-danger">*</span>
                      </label>
                      <Field
                        as="select"
                        className={`form-select`}
                        name="wardNo"
                        disabled={!values.zoneNo}
                      >
                        <option value="">Select Ward</option>
                        {masterData.wards
                          .filter(
                            (ward) => ward.ucczoneId === parseInt(values.zoneNo)
                          )
                          .map((ward) => (
                            <option key={ward.wardId} value={ward.wardNo}>
                             {`${ward.wardNo} - ${ward.wardName}`}
                            </option>
                          ))}
                      </Field>
                      <ErrorMessage
                        name="wardNo"
                        component="div"
                        className="text-danger"
                      />
                    </div>

                    <div className="col-md-3 mb-3">
                      <label className="form-label">
                        Commercial Room Attached
                        <span className="text-danger">*</span>
                      </label>
                      <Field
                        as="select"
                        className="form-select"
                        name="isCommercial"
                      >
                        <option value={true}>Yes</option>
                        <option value={false}>No</option>
                      </Field>
                      <ErrorMessage
                        name="isCommercial"
                        component="div"
                        className="text-danger"
                      />
                    </div>
                    {values.isCommercial === "true" && (
                      <div className="col-md-3 mb-3">
                        <label className="form-label">
                          Municipal Commercial No{" "}
                          <span className="text-danger">*</span>
                        </label>
                        <Field
                          type="text"
                          className="form-control"
                          name="MunicipalCommercialNo"
                        />
                        <ErrorMessage
                          name="MunicipalCommercialNo"
                          component="div"
                          className="text-danger"
                        />
                      </div>
                    )}
                    {/* 
                    <div className="col-md-3 mb-3">
                      <label className="form-label d-block">
                        Is Active<span className="text-danger">*</span>
                      </label>
                      <div className="form-check form-check-inline">
                        <Field
                          className="form-check-input"
                          type="radio"
                          name="isActive"
                          id="activeYes"
                          value={true}
                          checked={values.isActive === true}
                          onChange={() => setFieldValue("isActive", true)}
                        />
                        <label className="form-check-label" htmlFor="activeYes">
                          Active
                        </label>
                      </div>
                      <div className="form-check form-check-inline">
                        <Field
                          className="form-check-input"
                          type="radio"
                          name="isActive"
                          id="activeNo"
                          value={false}
                          checked={values.isActive === false}
                          onChange={() => setFieldValue("isActive", false)}
                        />
                        <label className="form-check-label" htmlFor="activeNo">
                          Inactive
                        </label>
                      </div>
                    </div> */}
                    {/* Image URL and Preview */}
                    <div className="col-md-6 mb-3">
                      <label className="form-label">
                        Image<span className="text-danger">*</span>
                      </label>
                      <div className="d-flex gap-3 flex-column">
                        {/* Show current image if available */}
                        {typeof values.imageUrl === "string" &&
                          values.imageUrl && (
                            <div className="mt-2">
                              <img
                                src={values.imageUrl}
                                alt="Property"
                                className="img-thumbnail"
                                style={{ maxHeight: "100px" }}
                              />
                            </div>
                          )}

                        {/* File input for uploading new image */}
                        <div>
                          <input
                            type="file"
                            className={`form-control`}
                            onChange={(event) => {
                              const file = event.currentTarget.files[0];
                              if (file) {
                                setFieldValue("imageUrl", file);
                              }
                            }}
                          />
                          <small className="form-text text-muted">
                            Upload a new image or keep the existing one
                          </small>
                          <ErrorMessage
                            name="imageUrl"
                            component="div"
                            className="text-danger"
                          />
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="d-flex gap-3 mt-4">
                    <button
                      type="submit"
                      className="btn btn-primary"
                      disabled={isSubmitting}
                    >
                      {isSubmitting ? "Saving..." : "Save"}
                    </button>
                    <button
                      type="button"
                      className="btn btn-secondary"
                      onClick={() => navigate(-1)}
                    >
                      Cancel
                    </button>
                  </div>
                </Form>
              )}
            </Formik>
          </div>
        </div>
      </main>
    </div>
  );
}

export default UnVerifiedReportAddForm;
